
/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

require('./bootstrap.js');

import Swiper, { Navigation, Autoplay, Pagination, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

window.Swiper = Swiper;

(function ($) {

    $(document).ready(function  () {

        var KEYCODE_ESC = 27;

        $(document).keyup(function(e) {
            if (e.keyCode == KEYCODE_ESC) {
                $('.pop_can').click();
                $('.pop_can_compare').click();
            }
        });

        window.incrementShoppingCart = function() {
            var number = $("#cart_item_amount").html();
            number++;
            $("#cart_item_amount").text(number);
        };

        window.decrementShoppingCart = function() {
            var number = $("#cart_item_amount").html();
            number--;
            $("#cart_item_amount").text(number);
        };

        $(".complare-popup-content").on("click", function(e){

            $(this).data("clicked", true);
        });

        $(".popup-complare-overlay.specify-popup").on("click", function(e){


            var element = $(".complare-popup-content");
            if(element.data('clicked')) {
                element.data("clicked", false);
            } else {
                $('.pop_can_compare').click();
            }
        });


        // file upload button

        $('#file-field').change(function () {
            $('.file-name').html(this.files[0].name).show();
            $('.clear-file-input').css('display', 'inline-block');
        });

        $('.clear-file-input').on('click', function () {
            $('#file-field').val('');
            $('.file-name').html($('#file-field').val());
            $('.clear-file-input').css('display', 'none');
        });


        // popup

        $('.pop_can').click(function (e) {
            e.preventDefault();
            $('body').removeClass('show-login-popup show-registration-popup show-reset-popup ');
            $('.specify-popup .form-section input[type=email], .specify-popup .form-section input[type=password]').val('')
        });

        $('.pop_can_compare').click(function (e) {
            e.preventDefault();
            $('body').removeClass('show-complare-popup');
        });


        // filter-collapse-btn

        $('.search-filters-toggle').click(function () {
            $('.staalwijzer').toggleClass('search-filters-active').removeClass('sidebar-filters-active').removeClass('content-active');
        });
        $('.sidebar-filters-toggle').click(function () {
            $('.staalwijzer').toggleClass('sidebar-filters-active').removeClass('search-filters-active').removeClass('content-active');
        });

        $('.filter-section-header').click(function (event) {
            if(! event.target.classList.contains('fas')) {
                $(this).parent().toggleClass('active')
            }
        });


        // custom select field
        $('.select-field').each(function () {

            if(this.classList.contains('no-modify')) return;

            // Cache the number of options
            var $this = $(this),
                numberOfOptions = $(this).children('option').length;

            // Hides the select element
            $this.addClass('select-s-hidden');

            // Wrap the select element in a div
            $this.wrap('<div class="select"></div>');

            // Insert a styled div to sit over the top of the hidden select element
            $this.after('<div class="select-styledSelect"></div>');

            // Cache the styled div
            var $styledSelect = $this.next('div.select-styledSelect');

            // Show the first select option in the styled div
            $styledSelect.text($this.children('option').eq(0).text());

            // Insert an unordered list after the styled div and also cache the list
            var $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);

            // Insert a list item into the unordered list for each select option
            for (var i = 0; i < numberOfOptions; i++) {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list);
            }

            // Cache the list items
            var $listItems = $list.children('li');

            // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
            $styledSelect.click(function (e) {
                e.stopPropagation();
                $('div.styledSelect.active').each(function () {
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
            });

            // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
            // Updates the select element to have the value of the equivalent option
            $listItems.click(function (e) {
                e.stopPropagation();
                $styledSelect.text($(this).text()).removeClass('active');
                var value = $(this).attr('rel').toString();
                $($this).val(value);
                $($this).trigger('change');
                $list.hide();
                / alert($this.val()); Uncomment this for demonstration! /
            });

            // Hides the unordered list when clicking outside of it
            $(document).click(function () {
                $styledSelect.removeClass('active');
                $list.hide();
            });
        });

        $('.burger_wrap').on('click', function () {
            $(this).toggleClass('active');
            $('.wpb_header .vacatures_wrap').toggle();
            $('html').toggleClass('menu-in');
        });

        $( window ).on( "resize", function() {
            if (window.innerWidth > 992 && document.documentElement.classList.contains("menu-in")) {
                $('.burger_wrap').removeClass('active');
                $('.wpb_header .vacatures_wrap').removeAttr("style");
                $('html').removeClass('menu-in');
            }
        });

        // range slider

        if ($('#terkvastheid').length > 0) {
            $('#terkvastheid').slider({
                range: true,
                min: 200,
                max: 1200,
                values: [ 0, 1000 ],
                slide: function( event, ui ) {
                    $(ui.handle).html("<span>"+ui.value+"</span>")
                }
            });
        }
        if ($('#gebruikshardheid').length > 0) {
            $('#gebruikshardheid').slider({
                range: true,
                min: 200,
                max: 1200,
                values: [ 0, 1000 ],
                slide: function( event, ui ) {
                    $(ui.handle).html("<span>"+ui.value+"</span>")
                }
            });
        }
    });
}(jQuery));



// WEBPACK FOOTER //
// ./resources/assets/js/app.js